// extracted by mini-css-extract-plugin
module.exports = {"comments":"comments__GRccf","dialog":"dialog__VpeeW","content":"content__OdcG4"};